// @ts-expect-error It is defined in webpack and cannot be resolved by typescript.
import serviceWorkerMiddleware from '@serviceWorker-middleware';

import authMiddleware from './auth-middleware';
import chronometerMiddleware from './chronometer-middleware';

const middleware = [chronometerMiddleware, authMiddleware, serviceWorkerMiddleware];

export default middleware;
